import { Div, Label } from '@kizi/core-components';
import React, { useState } from 'react';
import { DynamicFormModal } from '../../modals';
import { DefaultCheckbox } from './withFormProps';

export const CheckboxWrapper = ({ ...props }) => {
  const { _label, _labelProps } = props;
  const [showModal, setShowModal] = useState(false);

  let newLabel;
  let newLabelProps;
  let extractedHtml;

  if (_label?.includes('showExtraSupplierCost')) {
    const htmlPattern = /<.*>/g;
    let htmlMatches = _label.match(htmlPattern);
    extractedHtml = htmlMatches ? htmlMatches.join('') : '';
    newLabel = _label.replace(htmlPattern, '');
    newLabelProps = {
      ..._labelProps,
      dangerouslySetInnerHTML: {
        __html: _labelProps.dangerouslySetInnerHTML.__html?.replace(
          htmlPattern,
          ''
        ),
      },
    };
  }

  return newLabel ? (
    <>
      <DefaultCheckbox
        {...{ ...props, _label: newLabel, _labelProps: newLabelProps }}
      />
      {extractedHtml && (
        <Div pl={6}>
          <Label
            variant="lists.applyPageTermsAndPoliciesList"
            dangerouslySetInnerHTML={{
              __html: extractedHtml
                ?.replace('showExtraSupplierCost();', '')
                ?.replace('<a', `<a style='text-decoration: unset'`),
            }}
            onClick={() => setShowModal((p) => !p)}
          />
        </Div>
      )}
      <DynamicFormModal showModal={showModal} setShowModal={setShowModal} />
    </>
  ) : (
    <DefaultCheckbox {...props} />
  );
};
